import {cva} from 'class-variance-authority';

import {cn} from '../../lib/utils';
import {Separator} from '../shadcn/separator';

import type {VariantProps} from 'class-variance-authority';
import type React from 'react';

export const dividerVariantsConfig = {
  variants: {
    variant: {
      default: '',
      subtle: 'bg-border-subtle'
    }
  },
  defaultVariants: {variant: 'default'}
} as const;

const dividerVariants = cva('', dividerVariantsConfig);

export type DividerProps = React.ComponentProps<typeof Separator> &
  VariantProps<typeof dividerVariants>;

export function Divider({variant, className, ...props}: DividerProps) {
  return <Separator className={cn(dividerVariants({variant}), className)} {...props} />;
}
